import { render, staticRenderFns } from "./QuotationsList.vue?vue&type=template&id=1193958d&scoped=true"
import script from "./QuotationsList.vue?vue&type=script&lang=ts"
export * from "./QuotationsList.vue?vue&type=script&lang=ts"
import style0 from "./QuotationsList.vue?vue&type=style&index=0&id=1193958d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193958d",
  null
  
)

export default component.exports